import { useCallback } from 'react';
import type { ChromaticAberrationValue } from '../../lib/filters/chromatic-aberration';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Chromatic Aberration panel — single amount slider (pixel offset
 *  at corners). */
export function ChromaticAberrationPanel({
  value,
  onChange,
}: AdjustmentPanelProps<ChromaticAberrationValue>) {
  const set = useCallback(
    (patch: Partial<ChromaticAberrationValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Amount"
        min={0}
        max={30}
        step={1}
        value={value.amount}
        onChange={(v) => set({ amount: v })}
      />
    </div>
  );
}
